import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalSystemService } from '../local-system.service';

@Component({
  selector: 'app-fuji-service-presale-edit',
  templateUrl: './fuji-service-presale-edit.component.html',
  styleUrls: ['./fuji-service-presale-edit.component.css']
})
export class FujiServicePresaleEditComponent implements OnInit {
    service_num:any;
    editProtocol:any = { 'service_num':'60000', 'dealer_name':'', 'seller_name':'', 'date_of_service':'', 'date_of_return':'' }
    ac_list:any = [];
    modal:any = { "open":false, 'cntx':'', obj:{} };
    ac_list_serial:any = "";
    ac_list_model:any = "";

   constructor(public http:HttpClient, public router:Router, public system:LocalSystemService, public activatedRoute:ActivatedRoute) {
     this.service_num = this.activatedRoute.snapshot.params.uid;
     this.FetchService();
   }
 
   FetchService() {
     this.http.get("api/service.php?action=fetch_fuji_presale_service&protocol_id=" + this.service_num).subscribe((response) => {
      this.editProtocol['service_num'] = this.service_num;
      this.editProtocol['dealer_name'] = response['protocol']['dealer_name'];
      this.editProtocol['seller_name'] = response['protocol']['seller_name'];
      this.editProtocol['date_of_service'] = response['protocol']['date_of_service'];
      this.editProtocol['date_of_return'] = response['protocol']['date_of_return'];

      let model_list_split = response['protocol']['model_list'].split(";");
      let serial_list_split = response['protocol']['serial_list'].split(";");
      for(var mi = 0; mi < model_list_split.length; mi++) {
        this.ac_list.push({ 'model':model_list_split[mi], 'serial':serial_list_split[mi] });
      }
      this.ac_list.push({ 'model':'', 'serial':'' });
     });
   }
 
   ngOnInit(): void {
 
   }

   EditProtocol() {
    this.ac_list_model = "";
    this.ac_list_serial = "";
    for(var ai = 0; ai < this.ac_list.length; ai++) {
      if(ai > 0) {
        if(this.ac_list[ai].model != "" || this.ac_list[ai].serial != "") {
          this.ac_list_model += ";";
          this.ac_list_serial += ";";
        }
      }
      if(this.ac_list[ai].model != "" || this.ac_list[ai].serial != "") {
        this.ac_list_model += this.ac_list[ai].model;
        this.ac_list_serial += this.ac_list[ai].serial;
      }
    }
    this.openModal('editing-protocol', {});
    let post_data = { 'service_num':this.editProtocol.service_num, 'model_outdoor':this.editProtocol.model_outdoor, 'seller_name':this.editProtocol.seller_name, 'dealer_name':this.editProtocol.dealer_name, 'date_of_return':"",
    'serial_list':this.ac_list_serial, 'model_list':this.ac_list_model};
 
    this.http.post("api/service.php?action=edit_fuji_service_presale", post_data).subscribe((data) => {
      setTimeout(()=>{ 
        this.closeModal();
        this.router.navigate(['fuji-service-presale']);
      }, 500);
    });
   }

   changeAcRow(ac, i) {
    if(i == this.ac_list.length - 1) {
      if(ac.model != '' || ac.serial != '') {
        this.ac_list.push({ 'serial':'', 'model':'' });
      }
    }
  }

  removeItem(i) {
    this.ac_list.splice(i, 1);
  }

    // MODEL
    openModal(cntx, obj) { this.modal = { open:true, 'cntx':cntx, 'obj':obj } }
    closeModal() { this.modal.open = false; }

}
